const VirtualConferenceDashboardKeys = {
  all: ['VirtualConferenceDashboard'] as const,
  lists: () => [...VirtualConferenceDashboardKeys.all, 'list'] as const,
  filteredList: (sortOrder?: string, dateFrom?: string, dateTo?: string, organizationId?: string) =>
    [
      ...VirtualConferenceDashboardKeys.lists(),
      sortOrder,
      dateFrom,
      dateTo,
      organizationId,
    ] as const,
  organizations: () => [...VirtualConferenceDashboardKeys.all, 'organizations'] as const,
};

export { VirtualConferenceDashboardKeys };
